import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "Inter, sans-serif",
        color: "#111827",
      }}
    >
      {/* HERO */}
      <section
        style={{
          padding: "80px 20px 60px",
          textAlign: "center",
          background:
            "linear-gradient(to bottom, #ffffff, #f8fafc)",
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "inline-block",
              background: "#dcfce7",
              color: "#166534",
              padding: "10px 18px",
              borderRadius: 999,
              fontWeight: "bold",
              fontSize: 14,
              marginBottom: 18,
            }}
          >
            🔥 Nigerian TikTok Creators Are Getting Supported
          </div>

          <p
            style={{
              marginTop: 0,
              marginBottom: 30,
              color: "#6b7280",
              fontSize: 15,
            }}
          >
            Early creators are building audiences that support
            them directly.
          </p>

          <h1
            style={{
              fontSize: "clamp(2.5rem, 6vw, 5rem)",
              lineHeight: 1.05,
              marginBottom: 24,
              fontWeight: 900,
            }}
          >
            Turn Your
            <span style={{ color: "#f97316" }}>
              {" "}
              TikTok{" "}
            </span>
            Into Income
          </h1>

          <p
            style={{
              fontSize: 20,
              maxWidth: 720,
              margin: "0 auto",
              color: "#4b5563",
              lineHeight: 1.7,
            }}
          >
            Get direct fan support from your audience.
            Create a support link in seconds and start
            receiving payments from fans who love your
            content.
          </p>

          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
              flexWrap: "wrap",
              marginTop: 40,
            }}
          >
            <button
              onClick={() => navigate("/signup?source=income")}
              style={{
                background: "#f97316",
                color: "#fff",
                border: "none",
                padding: "18px 30px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
                boxShadow:
                  "0 10px 25px rgba(249,115,22,0.25)",
              }}
            >
              🚀 Start Receiving Support
            </button>

            <button
              onClick={() => navigate("/login")}
              style={{
                background: "#fff",
                color: "#111827",
                border: "2px solid #e5e7eb",
                padding: "18px 30px",
                borderRadius: 14,
                fontWeight: "bold",
                fontSize: 18,
                cursor: "pointer",
              }}
            >
              ▶ Creator Login
            </button>
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section
        style={{
          padding: "20px",
          maxWidth: 1100,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 24,
            padding: 30,
            border: "1px solid #e5e7eb",
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: 20,
            boxShadow:
              "0 10px 30px rgba(0,0,0,0.04)",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              🔥 Early Creators
            </h2>

            <p style={{ color: "#6b7280" }}>
              Already receiving fan support
            </p>
          </div>

          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              ⚡ Fast Payouts
            </h2>

            <p style={{ color: "#6b7280" }}>
              Receive support directly
            </p>
          </div>

          <div>
            <h2
              style={{
                fontSize: 32,
                margin: 0,
              }}
            >
              🇳🇬 Built For Nigeria
            </h2>

            <p style={{ color: "#6b7280" }}>
              Designed for Nigerian TikTok creators
            </p>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section
        style={{
          padding: "90px 20px",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: 60,
          }}
        >
          <h2
            style={{
              fontSize: 48,
              marginBottom: 14,
            }}
          >
            Start Getting Supported In Minutes
          </h2>

          <p
            style={{
              color: "#6b7280",
              fontSize: 18,
            }}
          >
            No complicated setup. No waiting.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(280px,1fr))",
            gap: 25,
          }}
        >
          {[
            {
              emoji: "🔗",
              title: "Paste Your TikTok Link",
              text:
                "Drop your TikTok content link and generate a support page instantly.",
            },
            {
              emoji: "📲",
              title: "Share With Fans",
              text:
                "Post your support link in bio, captions, comments, or videos.",
            },
            {
              emoji: "💸",
              title: "Receive Direct Support",
              text:
                "Fans support your content directly using simple payment options.",
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                borderRadius: 24,
                padding: 30,
                border: "1px solid #e5e7eb",
                boxShadow:
                  "0 8px 20px rgba(0,0,0,0.04)",
              }}
            >
              <div
                style={{
                  fontSize: 40,
                  marginBottom: 20,
                }}
              >
                {item.emoji}
              </div>

              <h3
                style={{
                  fontSize: 24,
                  marginBottom: 12,
                }}
              >
                {item.title}
              </h3>

              <p
                style={{
                  color: "#6b7280",
                  lineHeight: 1.7,
                }}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* CREATOR GUIDANCE */}
        <div
          style={{
            marginTop: 50,
            background: "#fff7ed",
            border: "1px solid #fed7aa",
            padding: 30,
            borderRadius: 24,
            textAlign: "center",
          }}
        >
          <h3
            style={{
              fontSize: 28,
              marginBottom: 14,
            }}
          >
            🎯 How creators get their first support
          </h3>

          <p
            style={{
              color: "#6b7280",
              lineHeight: 1.8,
              maxWidth: 700,
              margin: "0 auto",
              fontSize: 17,
            }}
          >
            Post a TikTok saying:
            <br />
            <br />
            “If you want to support my content, my support
            link is in bio.”
            <br />
            <br />
            Creators who ask directly usually receive their
            first support faster.
          </p>
        </div>
      </section>

      {/* FIRST MONEY SECTION */}
      <section
        style={{
          background: "#111827",
          color: "#fff",
          padding: "90px 20px",
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(320px,1fr))",
            gap: 40,
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-block",
                background: "#f97316",
                padding: "10px 18px",
                borderRadius: 999,
                marginBottom: 20,
                fontWeight: "bold",
              }}
            >
              🔥 FIRST SUPPORT MOMENT
            </div>

            <h2
              style={{
                fontSize: 48,
                lineHeight: 1.1,
                marginBottom: 20,
              }}
            >
              Your First ₦200 Changes Everything
            </h2>

            <p
              style={{
                color: "#d1d5db",
                lineHeight: 1.8,
                fontSize: 18,
              }}
            >
              Once creators receive their first support
              payment, they start posting more, sharing more,
              and growing faster.
            </p>
          </div>

          <div
            style={{
              background: "#1f2937",
              borderRadius: 24,
              padding: 30,
              border: "1px solid #374151",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 18,
              }}
            >
              {[
                "🔥 Anita received ₦500 support",
                "🔥 David received ₦200 support",
                "🔥 Tolu received ₦1,000 support",
              ].map((text, i) => (
                <div
                  key={i}
                  style={{
                    background: "#111827",
                    padding: 18,
                    borderRadius: 16,
                    fontWeight: 600,
                  }}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section
        style={{
          padding: "70px 20px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            maxWidth: 800,
            margin: "0 auto",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: "bold",
              marginBottom: 20,
            }}
          >
            🔒 Payments Secured by Flutterwave
          </div>

          <p
            style={{
              color: "#6b7280",
              lineHeight: 1.8,
              fontSize: 18,
            }}
          >
            Trusted payment infrastructure powering safe
            creator support payouts across Nigeria.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section
        style={{
          padding: "0 20px 100px",
        }}
      >
        <div
          style={{
            maxWidth: 1000,
            margin: "0 auto",
            background:
              "linear-gradient(to right, #f97316, #fb923c)",
            borderRadius: 32,
            padding: "70px 30px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(2rem,5vw,4rem)",
              lineHeight: 1.1,
              marginBottom: 20,
            }}
          >
            Start Receiving Fan Support Today
          </h2>

          <p
            style={{
              fontSize: 20,
              maxWidth: 700,
              margin: "0 auto 35px",
              lineHeight: 1.7,
            }}
          >
            Create your support link, share it with your
            audience, and turn your content into income.
          </p>

          <button
            onClick={() => navigate("/signup?source=income")}
            style={{
              background: "#fff",
              color: "#111827",
              border: "none",
              padding: "18px 30px",
              borderRadius: 14,
              fontWeight: "bold",
              fontSize: 18,
              cursor: "pointer",
            }}
          >
            🚀 Create My Support Link
          </button>
        </div>
      </section>
    </div>
  );
}